import { Family } from './Family';
export default Family;